import {EnvironmentBroker} from './broker/environment';
import {EnvironmentClient} from './client/environment';
import {AppName, EnvironmentName} from './environment-utils';

export const ENVIRONMENT = 'Environment';

export type EnvironmentShared = EnvironmentClient | EnvironmentBroker;

export interface EnvironmentMetadata {
  readonly supportRequestFilloutFrId?: string;
  readonly supportRequestFilloutEnId?: string;
  readonly showDevControls: boolean;
  readonly apiBase: string;
  readonly environment: EnvironmentName;
  readonly app: AppName;
  readonly msProposalApiBase: string;
  readonly msSaleApiBase: string;
  readonly msFnaApiBase: string;
  // Unused, remove when we do the clean up, I think it was meant to be used in index.html but its not
  readonly appTitle?: string;
  readonly enableProdMode?: boolean;
  readonly version: string;
  readonly disableAnimation?: boolean;
  readonly angularProdConfig?: boolean;
  readonly minutesUntilQuestionIdle?: number;
  readonly minutesUntilQuestionExpire?: number;
  readonly recaptchaSiteKey?: string;
  readonly optimizelyKey?: string;
  readonly paySafeApiKey?: string;
  readonly paySafeEnvironment?: string;
  // rename (FYI: broker app has the equivalent named "emmaAppOriginURL")
  readonly emmaAppUrl?: string;
  readonly datadogApplicationId?: string;
  readonly datadogLogsClientToken?: string;
  readonly datadogRumClientToken?: string;
  readonly datadogTrackInteraction?: boolean;
  readonly datadogTrackFrustration?: boolean;
  readonly segmentApiKey?: string;
  readonly launchDarklyClientId?: string;
  readonly stripePublishableKey?: string;
}
